import { useTranslation } from "react-i18next";
import { buildPlanMeter } from "@/components/packages/plan-card/planPips";
import { PLAN_TONE } from "@/components/packages/plan-card/planTone";
import type { StayPlanStatus } from "@/hooks/useStayPlanStatus";

export interface PlanCompactMeterProps {
  status: StayPlanStatus;
}

/** Resumo textual do consumo quando o card do plano está recolhido. */
export function PlanCompactMeter({ status }: PlanCompactMeterProps) {
  const { t } = useTranslation("patients");
  const meter = buildPlanMeter(status);
  const tone = PLAN_TONE[status.contract.module];
  if (!meter) return null;

  const isWeek = meter.kind === "week";
  const quotaUsed = meter.pips.filter((pip) => pip === "used").length;
  const used = isWeek ? quotaUsed : meter.used;
  const total = isWeek ? meter.pips.length : meter.total;

  return (
    <div className="text-end">
      <p className="flex items-baseline justify-end gap-1.5">
        <span className={`font-display text-xl font-extrabold leading-none ${tone.accent}`}>{used}</span>
        <span className="text-[0.8125rem] text-muted-foreground">
          {t("planCard.usedOfTotal", { count: used, total })}
        </span>
      </p>
    </div>
  );
}
